import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { BREAKPOINTS } from '../../../BeFi20.meta';

export const Wrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.bg,
  padding: 16,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    background: 'none',
    display: 'flex',
  },
}));
